import { render, staticRenderFns } from "./VideoPlaceHolder.vue?vue&type=template&id=081769aa&"
import script from "./VideoPlaceHolder.vue?vue&type=script&lang=js&"
export * from "./VideoPlaceHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports